import React from "react";
import { useLocation } from "react-router-dom";

interface OrgModParams {
	org: string;
	mod: string;
}

export function useOrgModParams(): OrgModParams {
	const { pathname } = useLocation();
	return React.useMemo(() => {
		const parts = pathname.split("/");
		const org = parts[1] || "";
		const mod = parts[2] || "";
		return { org, mod };
	}, [pathname]);
}
